export default "__VITE_ASSET__D6lkWfB7__"